import api from "@/plugins/axios";

const actions = () => ({
  showSnackbar(payload) {
    this.snackbar.show = payload.show;
    this.snackbar.text = payload.text;
    this.snackbar.timeout = payload.timeout;
    this.snackbar.type = payload.type;
    this.snackbar.position = payload.position;
  },
  async getWhatsNewNotifications() {
    const res = await api.get(`/api/notification?type=WHATS_NEW`);
    this.notifications = res.data;
    return res.data;
  },
});

export default actions;
